import * as Sentry from "@sentry/vue";
import { useFirebase } from "@/composables/useFirebase";

export const useReport = () => {
  const reportForm = reactive({
    chat_message_id: "",
    subject: "",
    description: "",
  });

  const { postData } = useApi();

  const { logEvent } = useFirebase();

  // const { $toast } = useNuxtApp();

  const resetReportForm = () => {
    reportForm.chat_message_id = "";
    reportForm.subject = "";
    reportForm.description = "";
  };

  const reportSend = async (body: IReport) => {
    // Send analytics
    logEvent("submit_report");
    // Try to fetch a response from the api
    try {
      await postData("/report", body);
    } catch (e: unknown) {
      const error = useApiError(e);
      // We don't need to send validation errors to sentry
      if (!error.isValidationError) {
        Sentry.captureException(e);
      }
      throw e;
    }
  };

  return {
    reportForm,
    resetReportForm,
    reportSend,
  };
};
